import { render, staticRenderFns } from "./settingWebzi.vue?vue&type=template&id=7683d5ae&scoped=true&"
import script from "./settingWebzi.vue?vue&type=script&lang=js&"
export * from "./settingWebzi.vue?vue&type=script&lang=js&"
import style0 from "./settingWebzi.vue?vue&type=style&index=0&id=7683d5ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683d5ae",
  null
  
)

export default component.exports